<template>
    <div>
        <div class="row">
            <dashboard-box class="col-md-12" borderColor="blue" :id="4">
                <template #title>
                    {{ trans('navbar.news') }}
                </template>
                <template v-if="newsItems.length">
                    <div class="newslist-container">
                        <dashboard-news-explorer :news-items="newsItems"></dashboard-news-explorer>
                    </div>
                </template>
                <div v-else class="course-list-container d-flex not-available-content">
                    <p class="courses-message ">{{ trans('miscellaneous.view.news.not-available') }}</p>
                </div>
            </dashboard-box>
            <dashboard-box class="col-md-6" borderColor="violet" :id="1">
                <template #title>
                    {{ trans('navbar.my_courses') }}
                </template>
                <template v-if="studentCourses.length">
                    <div v-for="studentCourse in studentCourses" :key="'sCourse-' + studentCourse.id"
                        class="course-list-container">
                        <div class="d-flex justify-content-between second-course-container">
                            <div class="dashboard-coursename" style="width: 70%">
                                <a class="w-full d-flex align-items-center" style="height: 100%"
                                    :href="route('course-view', { id: studentCourse.course.id, scId: studentCourse.id })">
                                    <span :title="studentCourse.course.name">{{ studentCourse.course.name }}</span>
                                </a>
                            </div>

                            <div class="action-menu justify-content-around align-items-center" style="width: 25%">

                                <student-course-details-viewer :student-course-id="studentCourse.id"
                                    :course-name="studentCourse.course.name" :course-id="studentCourse.course.id"
                                    :student="user" can-access-keep="true" :progress="studentCourse.passed_percentage"
                                    :read-only="studentCourse.user_id !== user.id"></student-course-details-viewer>
                            </div>
                        </div>
                        <p v-if="studentCourse.training" class="training-name-quiz-info"
                            :title="studentCourse.training.title">{{ studentCourse.training.title }}</p>
                    </div>
                    <a class="course-list-container d-flex view-all-courses" :href="route('my-courses')">
                        <p class="courses-message">{{ trans('miscellaneous.view.courses.available') }}</p>
                    </a>
                </template>
                <div v-else class="course-list-container d-flex not-available-content">
                    <p class="courses-message ">{{ trans('miscellaneous.view.courses.not-available') }}</p>
                </div>
            </dashboard-box>
            <dashboard-box class="col-md-6" :id="2" borderColor="yellow">
                <template #title>
                    {{ trans('navbar.my_quizes') }}
                </template>
                <template v-if="userQuizzes.length">
                    <div v-for="userQuiz in userQuizzes"
                        :key="'quiz-' + userQuiz.id"
                        class="course-list-container" >
                        <dashboard-quiz-item
                            :userQuiz="userQuiz"
                        />
                    </div>

                    <a class="course-list-container d-flex view-all-courses" :href="route('my-quizzes')">
                        <p class="courses-message">
                            {{ trans("miscellaneous.view.quizzes.available") }}
                        </p>
                    </a>
                </template>
                <div v-else class="course-list-container not-available-content d-flex">
                    <p class="courses-message">{{ trans('miscellaneous.view.quizzes.not-available') }}</p>
                </div>
            </dashboard-box>
            <dashboard-box class="col-md-8" :id="3" borderColor="red">
                <template #title>
                    {{ trans('navbar.my_calendar') }}
                </template>
                <student-calendar></student-calendar>
            </dashboard-box>
            <!-- New Achievments component -->
            <div class="col-12 mb-3 mb-lg-2 p-lg-2 p-md-1 mb-md-2 col-md-4">
                <div class="card card-accomplishments">
                    <div class="border-tile-color green"></div>
                    <div class="accomplishments-header">
                        {{ trans('miscellaneous.accomplishments') }}
                    </div>
                    <div class="accomplishments-container">
                        <p class="accomplishments-title">{{ trans('miscellaneous.progress.average') }}</p>
                        <a class="accomplishments-link">
                            <progress-ring :min="0" :max="100" ringEndColor="#F67E00"
                                class="accomplishment-svg not-available-content" ring-color="#F67E00"
                                :value="avgProgress" :text="avgProgress">
                            </progress-ring>
                        </a>
                    </div>
                    <div class="accomplishments-container">
                        <p class="accomplishments-title">{{ trans('miscellaneous.my-certificates') }}</p>
                        <a class="accomplishments-link" :href="route('user-certificates', { user_id: user.id })">
                            <img src="/images/svg-icons/marlms-enrolled-students-orange.svg" loading="lazy" alt=""
                                class="svg-with-hover-2 accomplishment-svg">
                        </a>
                    </div>
                </div>
            </div>
            <!-- <dashboard-box class="col-md-4" :id="4" borderColor="green">
                <template #title>
                    {{ trans('miscellaneous.accomplishments') }}
                </template>
                <div class="accomplishments-container">
                    <p class="accomplishments-title">{{ trans('miscellaneous.progress.average') }}</p>
                    <a class="accomplishments-link">
                        <progress-ring :min="0"
                            :max="100"
                            class="accomplishment-svg not-available-content"
                            ring-color="#808080"
                            :value="avgProgress"
                            :text="avgProgress">
                        </progress-ring>
                    </a>
                </div>
                <div class="accomplishments-container">
                    <p class="accomplishments-title">{{ trans('miscellaneous.my-certificates') }}</p>
                    <a class="accomplishments-link" :href="route('user-certificates', {user_id: user.id})">
                        <img src="/images/svg-icons/marlms-enrolled-students.svg" loading="lazy" alt="" class="svg-with-hover accomplishment-svg">
                    </a>
                </div>
            </dashboard-box> -->
        </div>
    </div>
</template>

<script>
import DashboardBox from "./Dashboard/DashboardBox";

export default {
    name: "Dashboard",
    components: {
        DashboardBox
    },
    props: {
        user: {
            type: Object,
            required: true,
        },
        studentCourses: {
            type: Array,
            default: () => [],
        },
        avgProgress: {
            type: Number,
            required: true,
        },
        userQuizzes: {
            type: Array,
            default: () => [],
        },
        newsItems: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({
        openQuiz: {},
    }),
}
</script>


<style>
.newslist-container {
    max-height: 320px;
    overflow-y: auto;
    margin-top: 15px;
}

.dashboard-coursename {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    color: grey;
    font-size: 0.9rem;
    font-weight: 600;
}

.dashboard-coursename a span {
    color: grey;
    font-size: 0.9rem;
    font-weight: 600;
}

.course-list-container {
    border-radius: 5px;
    padding: 0.25rem;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    border: 2px solid lightgray;
    margin: 0.3rem 0;
}

.course-list-container:first-child {
    margin-top: 15px;
}

.course-list-container:hover {
    box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.1), -2px -2px 5px rgba(0, 0, 0, 0.1);
    background: #ececec;
}

.dashboard-action-button {
    margin: 0 0 !important;
}

.training-name-quiz-info {
    border-top: 1px solid lightgray;
    font-size: 0.8rem;
    font-weight: 600;
    line-height: 1rem;
    margin-bottom: 0;
    padding-top: 0.25rem;
    color: #444;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.second-course-container {
    padding-bottom: 0.25rem;
}

.not-available-content:hover {
    box-shadow: none;
    /*transform: scale(1);*/
    user-select: none;
    cursor: default;
}

.accomplishments-container {
    display: flex;
    flex-direction: column;
    margin-top: 15px;
}

.accomplishments-container:nth-child(2) .svg-with-hover:hover {
    transform: scale(1.03);
}

.accomplishments-title {
    font-size: 1rem;
    font-weight: 600;
    text-align: center;
    color: #555;
    user-select: none;
}

.accomplishment-svg {
    position: unset !important;
    display: block !important;
    width: 60% !important;
    margin: auto auto;
}

.alert {
    font-weight: 600;
    width: 100%;
    text-align: center;
    font-size: 0.8rem;
    margin-bottom: 0.25rem;
}

.card-accomplishments {
    height: 100%;
    padding: 15px;
    position: relative;
}

.accomplishments-header {
    font-size: 1.1rem;
    font-weight: 700;
    line-height: 1.7rem;
    text-align: center;
}

@media screen and (max-width: 576px) {
    .card-accomplishments {
        height: auto;
    }

    .accomplishment-svg {
        position: unset !important;
        display: block !important;
        width: 40% !important;
        margin: auto auto;
    }
}
</style>
